/**
 * 複数セクションの追加が可能なsectionKeyのホワイトリスト
 *
 * これらのセクションでは「Add new」ボタンが表示され、
 * 同じsectionKeyの新しいセクションを追加できます。
 * また、セクションが1つでもサブヘッダー付きで表示されます。
 */
const MULTI_SECTION_ALLOWED_KEYS = [
  'OSInformation',
  'ProcessorInformation',
  'RAMInformation',
  'GPUInformation',
  'PortInformation',
  'StorageInformation',
  'Repair',
  'Usage',
] as const;

export type MultiSectionAllowedKey =
  (typeof MULTI_SECTION_ALLOWED_KEYS)[number];

export function isMultiSectionAllowedKey(
  key: string,
): key is MultiSectionAllowedKey {
  return MULTI_SECTION_ALLOWED_KEYS.includes(key as MultiSectionAllowedKey);
}
